import store from '@/store/index'
import service from '@/services/flags/FlagsService'

export const flagsModule = {
  namespaced: true,
  strict: process.env.NODE_ENV !== 'production',
  state: {
    flagsList: [],
    pagination: {
      current_page: 1,
      last_page: 1,
      per_page: 10,
    },
  },
  mutations: {
    SET_FLAGS_LIST(state, payload) {
      if (state.current_page) {
        state.pagination.current_page = payload.current_page
        state.pagination.last_page = payload.last_page
      }
      state.flagsList = payload.data ?? payload
    },
  },
  actions: {
    async getFlags({ commit }, query = null) {
      let response = await service.getFlagsAPI(query)

      if (query && query.todos)
        await localStorage.setItem('FLAGS', JSON.stringify(response))

      commit('SET_FLAGS_LIST', response)
    },
    async setFlags({ commit }, payload) {
      // metodo utilizado na filial ao recuperar
      if (payload.length > 0)
        await localStorage.setItem('FLAGS', JSON.stringify(payload))
      else localStorage.removeItem('FLAGS')
      commit('SET_FLAGS_LIST', payload)
    },
    async getFlag(descricao) {
      let response = await service.getFlagAPI(descricao)

      return response
    },
    async deleteFlag({ dispatch }, descricao) {
      let response = await service.delete(descricao)
      await dispatch('getFlags', { todos: 'S' })

      return response
    },
  },
  getters: {
    getFlags: (state) => {
      if (!store.state.authModule.authUser) return

      const lsFlags = localStorage.getItem('FLAGS')

      if (!lsFlags) return state.flagsList

      const aux = JSON.stringify(state.flagsList)
      if (lsFlags !== aux) {
        return state.flagsList
      } else {
        return JSON.parse(lsFlags)
      }
    },
  },
}
